import React from 'react';
import DivisorItem from "./divisor-item.jsx";
import {FaAddressCard, FaExternalLinkAlt} from "react-icons/fa";
import projectUtils from "../../../../../../../utils/project-utils.js";
import {FaCircleInfo} from "react-icons/fa6";

const NewsDetails = ({data}) => {
    return (
        <>
            <p className={`text-[16px] text-white font-bold  p-2 bg-[#ff8b40] mb-0`}>
                Notícia
            </p>
            <div className={"p-2"}>
                <DivisorItem icon={<FaExternalLinkAlt size={18}/>} text={"Link"} value={data.value}/>
                <DivisorItem icon={<FaCircleInfo size={18}/>} text={"Descrição"} value={data.additionalValue}/>
            </div>
        </>
    )
};

export default NewsDetails;